// Auto generated file, do not manually modify!
// com.hotpads.rentcreditreport.web.api.RentCreditReportWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ReportingForAllEnrollmentStatusResponseDto,
  ReportingForAllEnrollmentUpdateRequestDto,
  SendRequestForZillowPaymentsWebApiRequestDto,
  UsersGetResponseDto,
} from '../..';

export const RentCreditReportWebApiHandler_enrollmentStatus_Path = '/api/web/rentReporting/v1/enrollmentStatus';

/**
 * Get rent credit reporting for all enrollment status
 */
export const RentCreditReportWebApiHandler_enrollmentStatus = (client = getClient()) => {
  return httpFrontEndRequest<never, never, ReportingForAllEnrollmentStatusResponseDto>(
    {
      endpoint: RentCreditReportWebApiHandler_enrollmentStatus_Path,
      method: 'GET',
      contextPath: '/rent-credit-report',
    },
    client,
  );
};

export const RentCreditReportWebApiHandler_enrollmentUpdate_Path = '/api/web/rentReporting/v1/enrollmentUpdate';

/**
 * Update rent credit reporting for all enrollment status
 */
export const RentCreditReportWebApiHandler_enrollmentUpdate = (
  postData: ReportingForAllEnrollmentUpdateRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ReportingForAllEnrollmentUpdateRequestDto, void>(
    {
      endpoint: RentCreditReportWebApiHandler_enrollmentUpdate_Path,
      method: 'POST',
      contextPath: '/rent-credit-report',
      postData: postData,
    },
    client,
  );
};

export const RentCreditReportWebApiHandler_get_Path = '/api/web/rentReporting/v1/users/get';

/**
 * Get current logged in user info with enrollment status
 */
export const RentCreditReportWebApiHandler_get = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UsersGetResponseDto>(
    {
      endpoint: RentCreditReportWebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rent-credit-report',
    },
    client,
  );
};

export const RentCreditReportWebApiHandler_sendRequestForZillowPayments_Path =
  '/api/web/rentReporting/v1/sendRequestForZillowPayments';

/**
 * Send notification via rent-payment API
 */
export const RentCreditReportWebApiHandler_sendRequestForZillowPayments = (
  postData: SendRequestForZillowPaymentsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendRequestForZillowPaymentsWebApiRequestDto, void>(
    {
      endpoint: RentCreditReportWebApiHandler_sendRequestForZillowPayments_Path,
      method: 'POST',
      contextPath: '/rent-credit-report',
      postData: postData,
    },
    client,
  );
};
